













































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Marker } from '@/models/Retailer';
import http from '@/services/Http';

@Component
export default class RetailerMeetingSearch extends Vue {
    [x: string]: any;
    @Prop() public heroSearch!: boolean;
    @Prop() public meetingType!: 'video' | 'store' | 'home';
    public allRetailersData: Marker[] = [] as Marker[];
    public searchQuery: string = '';
    public selectedOrganizationId: string = '';
    public selectedNonBookableRetailerIndex: number = -1;
    get retailersWithSlots(): Marker[] {
        return this.allRetailersData.filter((r: Marker) => {
            if (this.meetingType === 'video') {
                return r.hasAvailableVideoTimeSlot === true;
            } else if (this.meetingType === 'store') {
                return r.hasAvailableStoreTimeSlot === true;
            } else if (this.meetingType === 'home') {
                return r.offersHomeMeetings === true;
            }
        });
    }
    get retailersWithoutSlots(): Marker[] {
        return this.allRetailersData.filter((r: Marker) => {
            if (this.meetingType === 'video') {
                return r.hasAvailableVideoTimeSlot !== true;
            } else if (this.meetingType === 'store') {
                return r.hasAvailableStoreTimeSlot !== true;
            } else if (this.meetingType === 'home') {
                return r.offersHomeMeetings !== true;
            }
        });
    }
    get selectedRetailer(): Marker | undefined {
        return this.allRetailersData.find((r: Marker) => {
            return r.organizationId === this.selectedOrganizationId;
        });
    }
    created() {
        if (typeof this.$route.query.retailer !== 'undefined' && this.$route.query.retailer !== null) {
            // this.setSelectedRetailer(this.$route.query.retailer as string);
            this.selectedOrganizationId = this.$route.query.retailer as string;
        }
        if (typeof this.$route.query.query !== 'undefined' && this.$route.query.query !== null) {
            this.searchQuery = this.$route.query.query as string;
            this.$nextTick(() => {
                this.findRetailers();
            });
        }
    }
    public setSelectedNonbookableRetailer(evt: InputEvent) {
        const target = evt.target as HTMLSelectElement;
        this.selectedNonBookableRetailerIndex = Number(target.value);
    }
    private updateQuerystring(searchQuery: string, retailerId: string) {
        if (searchQuery !== '' && this.$route.query.query !== searchQuery) {
            this.$router.push({ query: { query: searchQuery } });
        } else if (retailerId !== '' && retailerId !== this.$route.query.retailer) {
            this.$router.push({ query: { query: this.$route.query.query, retailer: retailerId } });
        }
    }
    public setSelectedRetailer(retailerId: string | undefined) {
        if (typeof retailerId !== 'undefined') {
            this.selectedOrganizationId = retailerId;
            this.updateQuerystring('', retailerId);
            this.$emit('retailerSelected', this.selectedRetailer);
        }
    }
    public findRetailers() {
        this.updateQuerystring(this.searchQuery, '');
        const retailerSearch = http.get('/api/retailer?query=' + this.searchQuery + '&t=null&gaggenau=&pagesize=all');
        retailerSearch.then((response: any) => {
            const data = response.json();
            data.then((reponse: Marker[]) => {
                this.allRetailersData = reponse as Marker[];
                if (typeof this.selectedOrganizationId !== 'undefined') {
                    this.$emit('retailerSelected', this.selectedRetailer);
                }
                window.scrollTo({ top: 350, behavior: 'smooth' });
            }).catch((e: any) => {
                console.error(e);
            });
        });
    }
}
